import React from "react";
import { Wrapper, StyledButton } from "views/Step1.styles";
import { Subtitle } from "components/atoms/Subtitle/Subtitle";
import RedButton from "components/atoms/RedButton/RedButton";
import { Container } from "components/atoms/Container/Container";
import Step1Data from "data/Step1Data";
import GlobalData from "data/GlobalData";
const Step1 = ({
  onSelectChallenges,
  selectedChallenges,
  setSelectedChallenges,
  lang,
}) => {
  let availableChallenges;
  if (lang === "pl") {
    availableChallenges = Step1Data.availableChallenges.pl;
  } else if (lang === "en") {
    availableChallenges = Step1Data.availableChallenges.en;
  } else {
    availableChallenges = Step1Data.availableChallenges.pl;
  }

  const handleChallengeSelect = (e, id, name) => {
    e.target.classList.toggle("selected");
    const selectedChallenge = { id, name };
    if (selectedChallenges.some((ch) => ch.id === id)) {
      setSelectedChallenges(selectedChallenges.filter((ch) => ch.id !== id));
    } else {
      setSelectedChallenges([...selectedChallenges, selectedChallenge]);
    }
  };

  const handleNext = () => {
    onSelectChallenges(selectedChallenges);
  };

  return (
    <Container>
      <Wrapper>
        <Subtitle>
          {lang === "pl" ? Step1Data.subtitle.pl : Step1Data.subtitle.en}
        </Subtitle>
        {availableChallenges.map((challenge) => (
          <StyledButton
            key={challenge.id}
            onClick={(e) =>
              handleChallengeSelect(e, challenge.id, challenge.name)
            }
            className={
              selectedChallenges.some((ch) => ch.id === challenge.id)
                ? "selected"
                : ""
            }
          >
            {challenge.name}
          </StyledButton>
        ))}

        {selectedChallenges.length > 0 && (
          <RedButton onClick={handleNext}>
            {lang === "pl"
              ? GlobalData.buttons.next.pl
              : GlobalData.buttons.next.en}
          </RedButton>
        )}
      </Wrapper>
    </Container>
  );
};

export default Step1;
